const routes = {
	index: {
		path: '/',
		exact: false,
	},
	meetingListPage: {
		path: '/meeting/list',
		exact: true,
	},
	meetingPage: {
		getPath: (id: string): string => `/meeting/${id}`,
		path: '/meeting/:id',
		exact: false,
	},
	ssoCallback: {
		path: '/sso-callback',
		exact: true,
	},
	silentRenew: {
		path: '/silent-renew.html',
	},
	ssoRedirect: {
		path: '/sso-redirect',
		exact: true,
	},
	authenticationError: {
		path: '/auth-error',
		exact: true,
	},
};

export {routes};